import styles from './FooterCellWrapper.module.scss';

import React from 'react';

export const FooterCellWrapper: React.FC = (props) => {
  return <div className={styles.wrapper} {...props} />;
};
